import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { FlowIntroduceCard } from './FlowIntroduce'
import { TradeSessionDetailSkeletonProps } from './interface'
import { ProductDescriptionCard } from './ProductDescription'

const useStyles = createStyles(({ token }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: token.paddingSM
  }
}))

export const TradeSessionDetailSkeleton = ({
  children,

  /* -------------------------------------------------------------------------- */
  /*                              DetailTabs Props                              */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: PropsWithChildren<TradeSessionDetailSkeletonProps>) => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      {children}
      <FlowIntroduceCard />
      <ProductDescriptionCard {...restProps} />
    </div>
  )
}
